module.exports = __webpack_public_path__ + "media/promo/advent/images/cells/cell-29-3119d0e3d30f6f3118da4b9c78c25544.png";